module.exports = __webpack_public_path__ + "img/ic_date.451f04de.svg";